import { sendEventInMixpanel } from './mixpanel';
import { sendEventInIntercom } from './intercom';
import type { BiEvent } from './events';
import { PAGE_VISIT_EVENTS } from './events';

const pageVisitsEventNames: string[] = Object.values(PAGE_VISIT_EVENTS);

//Product definition
const isRelevantForIntercom = (eventName: BiEvent) => {
  const isPageVisit = pageVisitsEventNames.includes(eventName.name);
  return !isPageVisit;
};

export const sendBiEvent = (event: BiEvent) => {
  sendEventInMixpanel(event);
  if (isRelevantForIntercom(event)) {
    sendEventInIntercom(event);
  }
};
